export interface DimensionValue {
  id: string
  name: string
}

interface BaseDimensionAssignment {
  id: string
  name: string
  options: DimensionValue[]
}

export type SingleValueDimensionAssignment = BaseDimensionAssignment & {
  type: 'single-value'
  assignmentValue?: DimensionValue
  membershipId?: string
}

export type MutipleValueDimensionAssignment = BaseDimensionAssignment & {
  type: 'multiple-value'
  assignments: (DimensionValue & { percentage: number })[]
}

export type DimensionWithEmployeeAssignment =
  | SingleValueDimensionAssignment
  | MutipleValueDimensionAssignment

export const UNASSIGNED = 'unassigned'
